export function createCombinatorString(items: string[]): string {
  const formatter = new Intl.ListFormat();

  return formatter.format(items);
}
